require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-contact-center-notice.json") })
        }
      }, "path---es-articles-contact-center-notice");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-contact-center-notice!./.cache/json/es-articles-contact-center-notice.json
// module id = 2084
// module chunks = 231608221292675